import { Injectable } from '@angular/core';
import { ApiService } from '../../../shared/services/api.service';
import { HttpClient } from '@angular/common/http';
import { apiPaths } from '../../../config/api';

@Injectable({
  providedIn: 'root'
})
export class RegisterActivationService extends ApiService<any>{

  constructor(http: HttpClient) {
    super(apiPaths.auth.registerActivation, http);
  }
}
